import type { ReactNode } from 'react';

import FontIcon from '@/shared/ui/FontIcon';

import type { IconName } from '@wiw/icons';
import classnames from 'classnames';

import '@/shared/ui/assets/styles/WarningBanner.scss';

type Props = {
  children: ReactNode;
  wrapperClass?: string;
  icon?: IconName;
  level?: 'warning' | 'error';
  onDismiss?: () => void;
};

export default function WarningBanner({ children, wrapperClass, icon = 'alert', level = 'warning', onDismiss }: Props) {
  const className = classnames('warning-banner', wrapperClass);
  return (
    <div className={className}>
      <FontIcon icon={icon} className={classnames('lg', level)} />
      <div className="notice">{children}</div>
      {onDismiss && (
        <button type="button" className="close-btn btn px-0 py-0">
          <FontIcon icon="close" onClick={onDismiss} />
        </button>
      )}
    </div>
  );
}
